// QRCode.jsx
import React, { useEffect, useState } from "react";
import QRCodeStyling from "qr-code-styling";

const QRCode = ({ url, size, onReady }) => {
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    if (!url) return;

    const qr = new QRCodeStyling({
      width: size * 4,   // high resolution for print
      height: size * 4,
      data: url,
      dotsOptions: { color: "#000", type: "rounded" },
      backgroundOptions: { color: "#fff" }
    });

    qr.getRawData("png").then((blob) => {
      if (!blob) return;
      const objectUrl = URL.createObjectURL(blob);
      setImgSrc(objectUrl);

      if (onReady) onReady();     // IMPORTANT FIX
    });
  }, [url]);

  if (!imgSrc) return null;

  return (
    <img
      src={imgSrc}
      width={size}
      height={size}
      alt="QR"
      style={{ display: "block" }}
    />
  );
};

export default QRCode;
